import {
    LEADS_LIST,
    LEADS_COUNT_RELATED_DATA,
    ASSIGNED_LEADS_LIST,
    CREATE_LEADS,
    UPDATE_LEADS,
    CLEAR_LEADS_ERRORS,
    UPDATE_LEADS_STATUS,
    DELETE_LEADS,
    GET_LEADS_DETAILS, SHARE_LEADS,
} from "@/core/services/store/leads.module";
import {mapState} from "vuex";
// import ViewsSelection from "@/view/pages/realstate/selections/ViewsSelection";
import {SET_CONFIRMATION} from "@/core/services/store/confirmation.module";
import {INQUIRYSTATUSES_SIMPLE_LIST} from "@/core/services/store/inquiry_statuses.module";
import {CONTACTS_SIMPLE_LIST, VERIFY_EMAILS} from "@/core/services/store/contacts.module";
import {STAFF_LIST} from "@/core/services/store/users.module";
import {PROJECTS_SIMPLE_LIST, PROJECTS_SIMPLE_BY_IDS_LIST} from "@/core/services/store/projects.module";
import {
    DEVELOPMENTS_SIMPLE_LIST,
    DEVELOPMENTS_SIMPLE_BY_IDS_LIST,
    DEVELOPMENTS_WITH_COUNT,
    DEVELOPMENTS_AND_PROJECTS_SIMPLE_LIST
} from "@/core/services/store/developments.module";
import {LISTINGS_SIMPLE_LIST, LISTINGS_SIMPLE_BY_IDS_LIST} from "@/core/services/store/listings.module";
import LeadComments from "@/view/pages/realstate/leads/inc/LeadComments";
import SharedLeads from "@/view/pages/realstate/leads/inc/SharedLeads";
import OfferedListings from "@/view/pages/realstate/leads/inc/OfferedListings";
import {PURPOSES_SIMPLE_LIST} from "@/core/services/store/purposes.module";
import {VIEWS_SIMPLE_LIST} from "@/core/services/store/views.module";
import {DEVELOPMENTTYPES_SIMPLE_LIST} from "@/core/services/store/developmenttypes.module";
import {bus} from "@/main";
import {VERIFY_AUTH} from "@/core/services/store/auth.module";
import {REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module";
import {SOURCES_SIMPLE_LIST} from "@/core/services/store/sources.module";
import SendEmail from "@/view/pages/realstate/contacts_management/inc/SendEmail";
import ActivityLogsPanel from "@/view/pages/realstate/logs/ActivityLogsPanel.vue";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

const bedroomOptions = ['Studio'].concat(Array.from({length: 20}, (_, i) => String(i + 1)));
const bathroomOptions = Array.from({length: 20}, (_, i) => String(i + 1));
const plotPropertyTypeKeywords = ['villa', 'townhouse', 'bungalow', 'stack house'];
const LEAD_MAX_LOCATIONS = 4;
const listingsScript = {
    name: 'leads',
    components: {LeadComments, OfferedListings, SharedLeads, SendEmail, ActivityLogsPanel},
    data() {
        return {
            headers: [
                {text: 'Purpose', value: 'purpose.title', name: 'purpose.title', filterable: false, sortable: false},
                {text: 'Beds', value: 'no_of_bedrooms', name: 'no_of_bedrooms', filterable: false, sortable: false},
                {text: 'Bathroom', value: 'no_of_bathrooms', name: 'no_of_bathrooms', filterable: false, sortable: false},
                {text: 'Location', value: 'location', name: 'location', filterable: false, sortable: false},
                {text: 'Built Up Area', value: 'built_up_area', name: 'built_up_area', filterable: false, sortable: false},
                {text: 'Plot Area', value: 'plot_area', name: 'plot_area', filterable: false, sortable: false},
                {text: 'Min Budget', value: 'min_budget', name: 'min_budget', filterable: false, sortable: false},
                {text: 'Max Budget', value: 'max_budget', name: 'max_budget', filterable: false, sortable: false},
                {text: "Created", align: ' d-none', value: "comment_updated_at", name: "comment_updated_at", filterable: false, sortable: true},
                {text: 'Actions', value: 'actions', name: 'actions', filterable: false, sortable: false},
            ],
            draw: 1,
            searchQuery: "",
            loading: true,
            pagination: {
                page: 1,
                itemsPerPage: 25,
                rowsPerPage: 25,
                totalItems: 0,
                sortDesc: "desc"
            },
            totalRecords: 0,
            rowsPerPageItems: [25, 50, 100, 150, 200],
            headerindex: "",
            inquiryStatusesFilter: [],
            viewsFilter: [],
            viewsIdsFilter: [],
            isLoaded: true,
            contactsFilter: [],
            mortgageBanksFilter: [],
            isLoadedContacts: false,
            isLoadedMBContacts: false,
            loadRequestId: 0,
            projectsFilter: [],
            isProjectsLoaded: false,
            staffFilter: [],
            columns: [],
            validationRules: {
                valid: true,
                titleRules: [
                    v => !!v || "This field is required",
                    v => (v && v.length >= 3) || "Must be greater than 3 characters",
                    v => (v && v.length <= 200) || "Must be less than 200 characters"
                ],
                selectRule: [
                    (v) => {
                        if (!v || v.length < 1)
                            return 'Select an option';
                        else return true;
                    }
                ],
                multipleRules: [
                    v => {
                        if (!v || v.length < 1) return "Select at least one option";
                        else return true;
                    }
                ]
            },
            items: [],
            dialog: false,
            editedItem: {},
            purposesFilter: [],
            sourcesFilter: [],
            listingsFilter: [],
            isListingsLoaded: false,
            searchFormData: {},
            developmentsFilter: [],
            isDevelopmentsLoaded: false,
            locationsFilter: [],
            isLocationsLoaded: false,
            leadLocationSearch: null,
            contactsSearch: null,
            listingsSearch: null,
            filterLocationsSearchInput: null,
            filterListingsSearchInput: null,
            filterLocationsFilter: [],
            isFilterLocationsLoaded: false,
            filterListingsFilter: [],
            isFilterListingsLoaded: false,
            ptFilter: [],
            bedroomOptions,
            bathroomOptions,
            furnishedOptions: [
                {value: 1, title: 'Yes'},
                {value: 0, title: 'No'}
            ],
            builtUpAreaUnit: '',
            plotAreaUnit: '',
            typesOfLead: [
                {value: 'dev', title: "Master/Sub Development"},
                {value: 'pro', title: "Project"},
                {value: 'lis', title: "Listing"}
            ],
            showScopeOptions: [
                {value: 'all', title: 'All Leads'},
                {value: 'assigned', title: 'Leads Assigned To Me'},
            ],
            showScope: 'all',
            advSHitted: false,
            shareDialog: false,
            leadSharingIds: [],
            treeDialog: false,
            treeItems: [],
            emailDialog: false,
            emailMsg: '',
            vEmails: [],
            leadRD: false,
            leadRR: '',
            leadRI: {},
            leadStatuses: [
                {value: 0, title: "Reject"},
                {value: 1, title: "Accept"}
            ],
            activityLogsDialog: false,
            activityLogsLeadId: null,
            activityLogsTitle: '',
            offerDialog: false,
            offerLeadItem: {},
        }
    },
    watch: {
        // params: {
        //     handler() {
        //         this.loadData().then(response => {
        //             this.items = response.items;
        //             this.totalRecords = response.total;
        //         });
        //     },
        //     deep: true
        // },
        dupDialog(val) {
            if (!val) this.dupItem = '';
            if (!val) this.duplicatedItem = {p_id: '', p_type_id: ''}
        },
        dialog(val) {
            !val && this.$store.dispatch(CLEAR_LEADS_ERRORS);
            if (!val) this.$store.state.selections.selectedFolderId = ''
            if (!val) {
                let that = this;
                setTimeout(function () {
                    that.editedItem.message = '';
                }, 500)
            }
            if (!val) {
                this.editedItem = {};
                this.locationsFilter = [];
            }
            // if (!val) this.$store.state.selections.selectedViewIds = []
            if (val) {
                if (!Array.isArray(this.editedItem.contact_ids)) {
                    this.$set(this.editedItem, 'contact_ids', []);
                }
                if (!Array.isArray(this.editedItem.location_uids)) {
                    this.$set(this.editedItem, 'location_uids', []);
                }
                this.builtUpAreaUnit = this.builtUpAreaUnit ? this.builtUpAreaUnit : this.$store.state.auth.user.measurement_unit
                this.plotAreaUnit = this.plotAreaUnit ? this.plotAreaUnit : this.$store.state.auth.user.measurement_unit
                if (!this.ptFilter.length) this.getPropertyTypes(false);
            } else {
                this.builtUpAreaUnit = ''
                this.plotAreaUnit = ''
            }
        },
        shareDialog(val) {
            if (val) {
                const index = this.staffFilter.findIndex(element => {
                    if (element.id === this.$store.state.auth.user.id) {
                        return true;
                    }
                });
                if (index !== -1) this.staffFilter.splice(index, 1);
            }
            if (!val) this.leadSharingIds = [];
        },
        leadRD(val) {
            if (!val) this.leadRI = {};
            if (!val) this.leadRR = '';
        },
    },
    mounted() {
        for (var i = 0; i < this.headers.length; i++) {
            this.columns.push(
                '&columns[' + i + '][data]=' + this.headers[i].value +
                '&columns[' + i + '][name]=' + this.headers[i].name +
                '&columns[' + i + '][searchable]=' + this.headers[i].filterable +
                '&columns[' + i + '][orderable]=' + this.headers[i].sortable +
                '&columns[' + i + '][search][value]=' +
                '&columns[' + i + '][search][regex]=' + false
            );
        }
        if (this.$route.query.hasOwnProperty('rel')) {
            this.$set(this.searchFormData, 'relId', parseInt(this.$route.query.rel, 10));
        }
        if (this.$route.query.hasOwnProperty('tol') && this.$route.query.hasOwnProperty('refs')) {
            if (this.$route.query.tol === 'listings') {
                this.$set(this.editedItem, 'type_of_lead', 'lis');
                if (this.$route.query.refs) {
                    this.getListingsByIds(this.$route.query.refs.split(','))
                }
            } else if (this.$route.query.tol === 'developments') {
                this.$set(this.editedItem, 'type_of_lead', 'dev');
                if (this.$route.query.refs) {
                    this.getDevelopmentsByIds(this.$route.query.refs.split(','))
                }
            } else if (this.$route.query.tol === 'projects') {
                this.$set(this.editedItem, 'type_of_lead', 'pro');
                if (this.$route.query.refs) {
                    this.getProjectsByIds(this.$route.query.refs.split(','))
                }
            } else {
                this.$set(this.editedItem, 'type_of_lead', null);
            }
        }
        this.showTree(0, 'all');
        this.getInquiryStatuses();
        this.loadData().then(response => {
            this.items = response.items;
            this.totalRecords = response.total;
        });
    },
    methods: {
        customFilter(item, queryText, itemText) {
            if (item.header || item.divider) {
                return true;
            }
            const searchText = queryText.toLowerCase();
            const itemTitle = item.text.toLowerCase();
            return itemTitle.includes(searchText);
        },
        getHeaderIndex(name) {
            let that = this;
            this.headers.filter(function (ele, i) {
                if (name == ele.name) {
                    that.headerindex = i;
                }
            });
        },
        loadData() {
            const requestId = ++this.loadRequestId;
            this.loading = true;
            this.isLoaded = true;
            this.items = [];
            this.totalRecords = 0;
            return new Promise((resolve) => {
                let params = this.params;
                const perPage = Number(params.itemsPerPage || params.rowsPerPage || 25);
                params.itemsPerPage = perPage;
                params.rowsPerPage = perPage;
                params.length = perPage; //set how many records to fetch per page
                params.start =
                    params.page == 1 ? 0 : perPage * (params.page - 1); //set offset
                params.draw = this.draw;
                let query = Object.keys(params).map((key) => {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                }).join('&');
                let searchFormDataQuery = this.buildSearchFormQuery();
                this.getHeaderIndex(params.sortBy && params.sortBy[0]);
                query += '&' + searchFormDataQuery
                query +=
                    "&search[value]=" +
                    (params.query || '') +
                    "&search[regex]=" +
                    false +
                    "&order[0][column]=" +
                    (params.sortBy && params.sortBy.length === 0 ? 8 : this.headerindex) +
                    "&order[0][dir]=" +
                    (params.sortDesc && params.sortDesc[0] ? "desc" : "asc");
                this.$store.dispatch(
                    this.showScope === 'assigned' ? ASSIGNED_LEADS_LIST : LEADS_LIST,
                    {
                        q: this.showScope === 'assigned' ? query : (query + '&defer_related_data=1'),
                        columns: this.columns
                    }
                ).then((res) => {
                    if (requestId !== this.loadRequestId) {
                        return;
                    }
                    let items = res.records.data;
                    let total = res.records.recordsFiltered;
                    this.totalRecords = (total !== null && total !== undefined) ? total : items.length;
                    this.loading = false;
                    this.isLoaded = false;
                    resolve({
                        items,
                        total: this.totalRecords
                    });
                    if (this.showScope === 'all') {
                        this.loadLeadsRelatedData(items, searchFormDataQuery);
                    }
                }).catch(() => {
                    if (requestId !== this.loadRequestId) {
                        return;
                    }
                    this.loading = false;
                    this.isLoaded = false;
                    resolve({
                        items: this.items,
                        total: this.totalRecords
                    });
                });
            });
        },
        buildSearchFormQuery() {
            return Object.keys(this.searchFormData || {}).map((key) => {
                const value = this.searchFormData[key];
                if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
                    return null;
                }
                if (Array.isArray(value)) {
                    if (!value.length) return null;
                    return encodeURIComponent(key) + '=' + encodeURIComponent(value.join(','));
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(value);
            }).filter(Boolean).join('&');
        },
        loadLeadsRelatedData(items, searchFormDataQuery) {
            if (this.$store.state.auth.user.type !== 1) return;
            let ids = (items || [])
                .map(item => (item ? item.id : null))
                .filter(id => id !== null && id !== undefined && id !== '');
            let relatedQuery = 'ids=' + encodeURIComponent(ids.join(',')) + '&' + searchFormDataQuery;
            this.$store.dispatch(LEADS_COUNT_RELATED_DATA, {q: relatedQuery}).then((res) => {
                if (res.records && res.records.filtered_count !== null && res.records.filtered_count !== undefined) {
                    this.totalRecords = res.records.filtered_count;
                }
                if (!ids.length || !res || !res.records || !res.records.data) return;
                let byId = {};
                res.records.data.forEach(row => {
                    byId[row.id] = row;
                });
                this.items.forEach(item => {
                    let data = byId[item.id];
                    if (!data) return;
                    const fields = [
                        'view_contact',
                        'comment_count',
                        'contact',
                        'lead_statuses',
                        'lead_comments',
                    ];
                    fields.forEach(field => {
                        if (Object.prototype.hasOwnProperty.call(data, field)) {
                            this.$set(item, field, data[field]);
                        }
                    });
                });
            });
        },
        refreshData(loadDep = true) {
            if (this.isLeadsListBusy) {
                return;
            }
            this.advSHitted = !this.advSHitted;
            this.loadData().then(response => {
                this.items = response.items;
                this.totalRecords = response.total ?? response.items.length;
                if (loadDep) this.getInquiryStatuses();
            });
        },
        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },
        onShowScopeChange() {
            this.pagination.page = 1;
            this.items = [];
            this.totalRecords = 0;
            this.loadData().then(response => {
                this.items = response.items;
                this.totalRecords = response.total ?? response.items.length;
            });
        },
        hitAdvanceSearch(reset = false) {
            if (this.isLeadsListBusy) {
                return;
            }
            this.pagination.page = 1
            this.advSHitted = !this.advSHitted;
            if (reset) {
                this.searchFormData = {};
                this.filterLocationsFilter = [];
                this.filterListingsFilter = [];
                this.showScope = 'all';
                this.showTree(0, 'all');
            }
            this.loadData().then(response => {
                this.items = response.items;
                this.totalRecords = response.total ?? response.items.length;
            });
        },
        showEditDialog(item) {
            this.$store.dispatch(GET_LEADS_DETAILS, item.id).then((data) => {
                this.editedItem = data.records || {};
                const contacts = Array.isArray(data.records.contacts) && data.records.contacts.length
                    ? data.records.contacts
                    : (data.records.contact ? [data.records.contact] : []);
                this.contactsFilter = contacts;
                this.$set(this.editedItem, 'contact_ids', Array.isArray(data.records.contact_ids) && data.records.contact_ids.length
                    ? data.records.contact_ids.map(id => Number(id))
                    : contacts.map(c => Number(c.id)));
                if (this.editedItem.contact_ids.length && !this.editedItem.contact_id) {
                    this.editedItem.contact_id = this.editedItem.contact_ids[0];
                }
                if (data.records.mortgage_bank) {
                    this.mortgageBanksFilter = [data.records.mortgage_bank];
                }
                const leadListings = Array.isArray(data.records.listings) ? data.records.listings : [];
                if (leadListings.length > 0) {
                    this.editedItem.type_of_lead = 'lis';
                    this.listingsFilter = this.mapLeadListingItems(leadListings);
                    this.$set(
                        this.editedItem,
                        'listing_ids',
                        (Array.isArray(data.records.listing_ids) && data.records.listing_ids.length
                            ? data.records.listing_ids
                            : leadListings.map((l) => l.id)
                        ).map((id) => Number(id))
                    );
                } else {
                    this.listingsFilter = [];
                    this.$set(
                        this.editedItem,
                        'listing_ids',
                        Array.isArray(data.records.listing_ids)
                            ? data.records.listing_ids.map((id) => Number(id))
                            : []
                    );
                }
                this.hydrateLeadLocations(data.records);
                this.builtUpAreaUnit = data.records.built_up_area_unit
                this.plotAreaUnit = data.records.plot_area_unit
                this.editedItem.min_price = this.addTSBV(data.records.min_price)
                this.editedItem.max_price = this.addTSBV(data.records.max_price)
                this.editedItem.min_built_up_area = this.addTSBV(data.records.min_built_up_area || data.records.built_up_area)
                this.editedItem.max_built_up_area = this.addTSBV(data.records.max_built_up_area)
                this.editedItem.min_plot_area = this.addTSBV(data.records.min_plot_area || data.records.plot_area)
                this.editedItem.max_plot_area = this.addTSBV(data.records.max_plot_area)
                this.editedItem.contact_budget = ''
                this.editedItem.pre_approved_amount = this.addTSBV(data.records.pre_approved_amount)
                if (data.records.property_type && !this.ptFilter.find(p => Number(p.id) === Number(data.records.property_type_id))) {
                    const pt = Object.assign({}, data.records.property_type);
                    if (!pt.full_title) {
                        pt.full_title = pt.parent ? (pt.title + ' (' + pt.parent.title + ')') : pt.title;
                    }
                    this.ptFilter = [pt, ...this.ptFilter];
                }
                this.$store.state.selections.selectedViewIds = this.editedItem.view_ids
                // this.staffFilter = data.records.users;
                this.dialog = !this.dialog;
            });
        },
        removeLeadContact(item) {
            const id = item && typeof item === 'object' ? Number(item.id) : Number(item);
            if (!Array.isArray(this.editedItem.contact_ids)) {
                this.$set(this.editedItem, 'contact_ids', []);
                return;
            }
            this.editedItem.contact_ids = this.editedItem.contact_ids.filter(cid => Number(cid) !== id);
            if (this.editedItem.contact_ids.length) {
                this.editedItem.contact_id = this.editedItem.contact_ids[0];
            } else {
                this.editedItem.contact_id = null;
            }
        },
        leadViewContacts(item) {
            if (item && Array.isArray(item.contacts) && item.contacts.length) {
                return item.contacts;
            }
            if (item && item.contact) {
                return [item.contact];
            }
            return [];
        },
        leadDevelopmentTypeLabel(development) {
            const type = development && development.type !== undefined && development.type !== null
                ? Number(development.type)
                : null;
            if (type === 0) return 'Master Development';
            if (type === 1) return 'Sub Development';
            return 'Development';
        },
        leadCardHasLocations(item) {
            return !!(item && ((item.developments && item.developments.length) || (item.projects && item.projects.length)));
        },
        leadCardIsCommercial(item) {
            const type = item && item.property_type ? item.property_type : null;
            if (!type) return false;
            const parentTitle = type.parent ? String(type.parent.title || '').toLowerCase() : '';
            const typeTitle = String(type.title || '').toLowerCase();
            const fullTitle = String(type.full_title || '').toLowerCase();
            return parentTitle.includes('commercial')
                || typeTitle.includes('commercial')
                || fullTitle.includes('commercial');
        },
        leadCardShowPlot(item) {
            const type = item && item.property_type ? item.property_type : null;
            if (!type) return false;
            const title = String(type.title || type.full_title || '').toLowerCase();
            return plotPropertyTypeKeywords.some((word) => title.includes(word));
        },
        leadFurnishedLabel(item) {
            if (!item || item.is_furnished === null || item.is_furnished === undefined || item.is_furnished === '') {
                return '-';
            }
            return Number(item.is_furnished) === 1 ? 'Yes' : 'No';
        },
        leadAreaRangeDisplay(minVal, maxVal, unit, fallbackSingle) {
            const min = minVal || fallbackSingle || '';
            const max = maxVal || '';
            const unitLabel = unit && unit !== 'Dimensions' ? (' ' + unit) : '';
            if (min && max) return String(min) + ' - ' + String(max) + unitLabel;
            if (min) return String(min) + unitLabel;
            if (max) return String(max) + unitLabel;
            return '-';
        },
        mapLeadListingItem(item) {
            if (!item) return item;
            const title = item.title || '';
            const uid = item.uid ? String(item.uid).toUpperCase() : '';
            return Object.assign({}, item, {
                display_title: uid ? (title + ' - ' + uid) : title
            });
        },
        mapLeadListingItems(items) {
            return (items || []).map((item) => this.mapLeadListingItem(item));
        },
        closeDialog() {
            this.dialog = !this.dialog;
        },
        showOfferListingsDialog(item) {
            this.$store.dispatch(GET_LEADS_DETAILS, item.id).then((data) => {
                const detail = data.records || {};
                this.offerLeadItem = Object.assign({}, item, detail, {
                    contact: detail.contact || item.contact,
                    contacts: (detail.contacts && detail.contacts.length)
                        ? detail.contacts
                        : (item.contacts && item.contacts.length ? item.contacts : (detail.contact || item.contact ? [detail.contact || item.contact] : [])),
                    contact_emails: detail.contact_emails || item.contact_emails || '',
                    user_names: item.user_names || detail.user_names || '',
                    view_titles: item.view_titles || detail.view_titles || '',
                });
                this.offerDialog = true;
            });
        },
        closeOfferListingsDialog() {
            this.offerDialog = false;
            this.$nextTick(() => {
                this.offerLeadItem = {};
            });
        },
        saveItem(item) {
            if (this.$refs.form.validate()) {
                let method = CREATE_LEADS;
                let id = item.id;
                let data = {
                    data: item
                };
                if (!Array.isArray(item.contact_ids) || !item.contact_ids.length) {
                    return;
                }
                item.contact_id = item.contact_ids[0];
                this.syncLeadLocationsToIds(item);
                if (!id) {
                    const locations = this.buildLeadLocationCreateRows(item);
                    if (!locations.length) {
                        this.$store.dispatch(SET_SNACK, {
                            clr: 'error',
                            msg: 'Please select at least one location.'
                        });
                        return;
                    }
                    item.locations = locations;
                    item.project_ids = [];
                    item.development_ids = [];
                } else {
                    this.$delete(item, 'locations');
                    if ((item.location_uids || []).length > LEAD_MAX_LOCATIONS) {
                        this.$store.dispatch(SET_SNACK, {
                            clr: 'error',
                            msg: 'You can select up to ' + LEAD_MAX_LOCATIONS + ' locations.'
                        });
                        return;
                    }
                }
                this.onLeadPropertyTypeChange();
                item.min_price = item.min_price ? String(item.min_price).replace(/,(?=\d{3})/g, '') : ''
                item.max_price = item.max_price ? String(item.max_price).replace(/,(?=\d{3})/g, '') : ''
                item.min_built_up_area = item.min_built_up_area ? String(item.min_built_up_area).replace(/,(?=\d{3})/g, '') : ''
                item.max_built_up_area = item.max_built_up_area ? String(item.max_built_up_area).replace(/,(?=\d{3})/g, '') : ''
                item.min_plot_area = item.min_plot_area ? String(item.min_plot_area).replace(/,(?=\d{3})/g, '') : ''
                item.max_plot_area = item.max_plot_area ? String(item.max_plot_area).replace(/,(?=\d{3})/g, '') : ''
                item.min_rent = ''
                item.max_rent = ''
                item.built_up_area = item.min_built_up_area || ''
                item.plot_area = item.min_plot_area || ''
                item.pre_approved_amount = item.pre_approved_amount ? String(item.pre_approved_amount).replace(/,(?=\d{3})/g, '') : ''
                // Contact Budget UI removed — never persist stale values.
                item.contact_budget = '';
                this.$set(item, "built_up_area_unit", this.builtUpAreaUnit);
                this.$set(item, "plot_area_unit", this.plotAreaUnit);
                // this.$set(item, "view_ids", this.$store.state.selections.selectedViewIds);
                if (id) {
                    method = UPDATE_LEADS;
                }
                this.$store.dispatch(CLEAR_LEADS_ERRORS);
                this.$store.dispatch(method, {'slug': id, data: data.data}).then((res) => {
                    this.loadData().then(response => {
                        this.items = response.items;
                        this.totalRecords = response.total;
                    });
                    this.dialog = !this.dialog;
                    bus.$emit("leadUpdatedByParent", res);
                })
            }
        },
        openLeadActivityLogs(item) {
            this.activityLogsLeadId = item.id;
            const contactName = item.contact && item.contact.full_name ? String(item.contact.full_name).trim() : '';
            this.activityLogsTitle = contactName !== ''
                ? (contactName + ' (Lead ' + (item.uid ? String(item.uid).toUpperCase() : ('#' + item.id)) + ')')
                : ('Lead ' + (item.uid ? String(item.uid).toUpperCase() : ('#' + item.id)));
            this.activityLogsDialog = true;
        },
        closeLeadActivityLogs() {
            this.activityLogsDialog = false;
            this.$nextTick(() => {
                this.activityLogsLeadId = null;
                this.activityLogsTitle = '';
            });
        },
        onActivityLogsDialogInput(open) {
            if (!open) {
                this.closeLeadActivityLogs();
            }
        },
        deleteItem(item) {
            let that = this;
            this.$store.dispatch(SET_CONFIRMATION, {
                title: "Are you sure?",
                msg: "You want to archive?",
                clr: 'red',
                callback: function () {
                    let id = item.id;
                    this.$store.dispatch(DELETE_LEADS, {
                        'id': id
                    }).then(() => {
                        that.loadData().then(response => {
                            that.items = response.items;
                            that.totalRecords = response.total;
                        });
                    });
                }
            });
        },
        getInquiryStatuses(loadNext = true) {
            this.$store.dispatch(INQUIRYSTATUSES_SIMPLE_LIST).then((data) => {
                this.inquiryStatusesFilter = data.records.inquiryStatusesList;
                if (loadNext) this.getSources()
            });
        },
        getSources(loadNext = true) {
            this.$store.dispatch(SOURCES_SIMPLE_LIST).then((data) => {
                this.sourcesFilter = data.records.sourcesList;
                if (loadNext) this.getPurposes()
            });
        },
        getPurposes(loadNext = true) {
            this.$store.dispatch(PURPOSES_SIMPLE_LIST).then((data) => {
                this.purposesFilter = data.records.purposesList;
                if (loadNext) this.getPropertyTypes()
            });
        },
        getPropertyTypes(loadNext = true) {
            this.$store.dispatch(DEVELOPMENTTYPES_SIMPLE_LIST, {type: 'all', is_property: 1}).then((data) => {
                const list = data.records.developmentTypesList || [];
                this.ptFilter = list.filter((v) => v.parent_id);
                if (loadNext) this.getViews()
            });
        },
        getViews(loadNext = true) {
            this.$store.dispatch(VIEWS_SIMPLE_LIST, {type: 'Properties'}).then((data) => {
                this.viewsFilter = data.records.viewsList;
                let that = this;
                this.viewsFilter.forEach(function (v) {
                    if (v.children.length > 0) {
                        v.children.forEach(function (vv) {
                            that.viewsIdsFilter.push(vv.id)
                        })
                    }
                })
                if (loadNext) this.getStaff()
            });
        },
        getStaff() {
            this.$store.dispatch(STAFF_LIST).then((data) => {
                this.staffFilter = data.records.staffList;
            });
        },
        mapLeadLocationItem(item, locationRef) {
            const ref = locationRef || item.location_ref || 'development';
            const id = item.id;
            const title = item.title || item.commercial_title || '';
            const type = item.type !== undefined && item.type !== null ? Number(item.type) : null;
            let locationTypeLabel = 'Development';
            if (ref === 'project') {
                locationTypeLabel = 'Project';
            } else if (type === 0) {
                locationTypeLabel = 'Master Development';
            } else if (type === 1) {
                locationTypeLabel = 'Sub Development';
            }
            return {
                ...item,
                id,
                title,
                text: item.text || title,
                type,
                location_ref: ref,
                location_type_label: locationTypeLabel,
                uid: ref + '-' + id
            };
        },
        hydrateLeadLocations(records) {
            const selected = [];
            (records.developments || []).forEach((d) => {
                selected.push(this.mapLeadLocationItem({
                    id: d.id,
                    title: d.commercial_title,
                    commercial_title: d.commercial_title,
                    text: d.commercial_title,
                    type: d.type
                }, 'development'));
            });
            (records.projects || []).forEach((p) => {
                selected.push(this.mapLeadLocationItem({
                    id: p.id,
                    title: p.title,
                    text: p.title
                }, 'project'));
            });
            this.locationsFilter = selected;
            this.$set(this.editedItem, 'location_uids', selected.map((l) => l.uid));
            this.syncLeadLocationsToIds(this.editedItem);
        },
        syncLeadLocationsToIds(item) {
            const uids = Array.isArray(item.location_uids) ? item.location_uids : [];
            const selected = (this.locationsFilter || []).filter((l) => uids.includes(l.uid));
            item.development_ids = selected.filter((l) => l.location_ref === 'development').map((l) => l.id);
            item.project_ids = selected.filter((l) => l.location_ref === 'project').map((l) => l.id);
        },
        buildLeadLocationCreateRows(item) {
            const uids = Array.isArray(item.location_uids) ? item.location_uids.slice(0, LEAD_MAX_LOCATIONS) : [];
            const selected = (this.locationsFilter || []).filter((l) => uids.includes(l.uid));
            return selected.map((l) => {
                if (l.location_ref === 'project') {
                    return {project_ids: [l.id], development_ids: []};
                }
                return {project_ids: [], development_ids: [l.id]};
            });
        },
        onLeadLocationChange(uids) {
            let selectedUids = Array.isArray(uids) ? uids : [];
            if (selectedUids.length > LEAD_MAX_LOCATIONS) {
                selectedUids = selectedUids.slice(0, LEAD_MAX_LOCATIONS);
                this.$store.dispatch(SET_SNACK, {
                    clr: 'error',
                    msg: 'You can select up to ' + LEAD_MAX_LOCATIONS + ' locations.'
                });
            }
            const selected = (this.locationsFilter || []).filter((l) => selectedUids.includes(l.uid));
            // Keep selected rows in filter so chips survive subsequent searches.
            const byUid = {};
            selected.forEach((l) => { byUid[l.uid] = l; });
            (this.locationsFilter || []).forEach((l) => {
                if (selectedUids.includes(l.uid)) byUid[l.uid] = l;
            });
            this.locationsFilter = Object.values(byUid).concat(
                (this.locationsFilter || []).filter((l) => !selectedUids.includes(l.uid))
            );
            this.$set(this.editedItem, 'location_uids', selectedUids);
            this.syncLeadLocationsToIds(this.editedItem);
            this.leadLocationSearch = null;
        },
        onLeadPropertyTypeChange() {
            if (!this.showLeadPlotAreas) {
                this.$set(this.editedItem, 'min_plot_area', null);
                this.$set(this.editedItem, 'max_plot_area', null);
            }
            if (this.isLeadCommercialPropertyType) {
                this.$set(this.editedItem, 'no_of_bedrooms', null);
                this.$set(this.editedItem, 'no_of_bathrooms', null);
            }
        },
        getDebouncedSearchQuery(e) {
            if (e == null) {
                return '';
            }
            if (typeof e === 'string') {
                return e;
            }
            if (e.target && e.target.value != null) {
                return String(e.target.value);
            }
            return '';
        },
        locationsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isLocationsLoaded = true;
                    const selected = (that.locationsFilter || []).filter((l) =>
                        Array.isArray(that.editedItem.location_uids) && that.editedItem.location_uids.includes(l.uid)
                    );
                    that.$store
                        .dispatch(DEVELOPMENTS_AND_PROJECTS_SIMPLE_LIST, {
                            type: 'all',
                            q: query,
                            countryId: that.$store.state.auth.user.country_id,
                            cityId: that.$store.state.auth.user.city_id
                        })
                        .then(data => {
                            const raw = (data && data.records && data.records.results) || [];
                            const results = raw.map((item) => that.mapLeadLocationItem(item));
                            const byUid = {};
                            selected.forEach((l) => { byUid[l.uid] = l; });
                            results.forEach((l) => { byUid[l.uid] = l; });
                            that.locationsFilter = Object.values(byUid);
                            that.isLocationsLoaded = false;
                        })
                        .catch(() => {
                            that.isLocationsLoaded = false;
                        });
                }
            }, 900);
        },
        filterLocationsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isFilterLocationsLoaded = true;
                    const selectedUids = Array.isArray(that.searchFormData.locationSearch)
                        ? that.searchFormData.locationSearch
                        : [];
                    const selected = (that.filterLocationsFilter || []).filter((l) => selectedUids.includes(l.uid));
                    that.$store
                        .dispatch(DEVELOPMENTS_AND_PROJECTS_SIMPLE_LIST, {
                            type: 'all',
                            q: query,
                            countryId: that.$store.state.auth.user.country_id,
                            cityId: that.$store.state.auth.user.city_id
                        })
                        .then(data => {
                            const raw = (data && data.records && data.records.results) || [];
                            const results = raw.map((item) => that.mapLeadLocationItem(item));
                            const byUid = {};
                            selected.forEach((l) => { byUid[l.uid] = l; });
                            results.forEach((l) => { byUid[l.uid] = l; });
                            that.filterLocationsFilter = Object.values(byUid);
                            that.isFilterLocationsLoaded = false;
                        })
                        .catch(() => {
                            that.isFilterLocationsLoaded = false;
                        });
                }
            }, 900);
        },
        filterListingsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = String(this.getDebouncedSearchQuery(e) || '').trim();
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isFilterListingsLoaded = true;
                    that.$store
                        .dispatch(LISTINGS_SIMPLE_LIST, {
                            type: 'all',
                            refId: query
                        })
                        .then(data => {
                            const selectedIds = Array.isArray(that.searchFormData.listingSearch)
                                ? that.searchFormData.listingSearch.map((id) => Number(id))
                                : [];
                            const selected = (that.filterListingsFilter || []).filter((item) =>
                                selectedIds.includes(Number(item.id))
                            );
                            const searched = that.mapLeadListingItems((data && data.records && data.records.listingsList) || []);
                            const byId = {};
                            selected.forEach((item) => { byId[item.id] = item; });
                            searched.forEach((item) => { byId[item.id] = item; });
                            that.filterListingsFilter = Object.values(byId);
                            that.isFilterListingsLoaded = false;
                        })
                        .catch(() => {
                            that.isFilterListingsLoaded = false;
                        });
                }
            }, 900);
        },
        developmentsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isDevelopmentsLoaded = true;
                    that.$store
                        .dispatch(DEVELOPMENTS_SIMPLE_LIST, {
                            q: query
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.developmentsList) || [];
                            that.developmentsFilter.push(...list);
                            that.isDevelopmentsLoaded = false;
                        })
                        .catch(() => {
                            that.isDevelopmentsLoaded = false;
                        });
                }
            }, 900);
        },
        projectsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isProjectsLoaded = true;
                    that.$store
                        .dispatch(PROJECTS_SIMPLE_LIST, {
                            q: query,
                            type: 'none'
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.projectsList) || [];
                            that.projectsFilter.push(...list);
                            that.isProjectsLoaded = false;
                        })
                        .catch(() => {
                            that.isProjectsLoaded = false;
                        });
                }
            }, 900);
        },
        listingsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = String(this.getDebouncedSearchQuery(e) || '').trim();
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isListingsLoaded = true;
                    that.$store
                        .dispatch(LISTINGS_SIMPLE_LIST, {
                            type: 'all',
                            refId: query
                        })
                        .then(data => {
                            const selectedIds = Array.isArray(that.editedItem.listing_ids)
                                ? that.editedItem.listing_ids.map((id) => Number(id))
                                : [];
                            const selected = (that.listingsFilter || []).filter((item) =>
                                selectedIds.includes(Number(item.id))
                            );
                            const searched = that.mapLeadListingItems((data && data.records && data.records.listingsList) || []);
                            const byId = {};
                            selected.forEach((item) => { byId[item.id] = item; });
                            searched.forEach((item) => { byId[item.id] = item; });
                            that.listingsFilter = Object.values(byId);
                            that.isListingsLoaded = false;
                        })
                        .catch(() => {
                            that.isListingsLoaded = false;
                        });
                }
            }, 900);
        },
        contactsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isLoadedContacts = true;
                    that.$store
                        .dispatch(CONTACTS_SIMPLE_LIST, {
                            role: 'All',
                            q: query
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.contactsList) || [];
                            that.contactsFilter = that.contactsFilter.concat(list);
                            that.isLoadedContacts = false;
                        })
                        .catch(() => {
                            that.isLoadedContacts = false;
                        });
                }
            }, 900);
        },
        mortgageBanksFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isLoadedMBContacts = true;
                    that.$store
                        .dispatch(CONTACTS_SIMPLE_LIST, {
                            role: 'UAE Banks',
                            q: query
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.contactsList) || [];
                            that.mortgageBanksFilter = that.mortgageBanksFilter.concat(list);
                            that.isLoadedMBContacts = false;
                        })
                        .catch(() => {
                            that.isLoadedMBContacts = false;
                        });
                }
            }, 900);
        },
        updateStatus(status, id, column) {
            this.$store.dispatch(CLEAR_LEADS_ERRORS);
            let data = {
                status: status,
                column: column
            };
            this.$store.dispatch(UPDATE_LEADS_STATUS, {'slug': id, data: data})
        },
        refreshComments(comment, item) {
            item.lead_comments = [comment, ...item.lead_comments]
            // item.contact_comments.push(comment);
            item.comment_count++;
        },
        getListingsByIds(ids) {
            const listingIds = Array.isArray(ids)
                ? ids.map((id) => String(id).trim()).filter(Boolean)
                : String(ids || '').split(',').map((id) => id.trim()).filter(Boolean);
            if (!listingIds.length) {
                return;
            }
            this.$store.dispatch(LISTINGS_SIMPLE_BY_IDS_LIST, {
                ids: listingIds.join(','),
                log_add_inquiry: true
            })
                .then((data) => {
                    this.listingsFilter = this.mapLeadListingItems(
                        (data && data.records && data.records.listingsList) || []
                    );
                    this.$set(this.editedItem, 'type_of_lead', 'lis');
                    this.dialog = true;
                    this.$nextTick(() => {
                        const listing = this.listingsFilter[0] || {};
                        this.$set(
                            this.editedItem,
                            'listing_ids',
                            this.listingsFilter.map((el) => el.id)
                        );
                        if (listing.purpose_id) {
                            this.$set(this.editedItem, 'purpose_id', listing.purpose_id);
                        }
                        if (listing.source_id) {
                            this.$set(this.editedItem, 'source_id', listing.source_id);
                        }
                        if (listing.property_type_id) {
                            this.$set(this.editedItem, 'property_type_id', listing.property_type_id);
                        }
                        this.$set(
                            this.editedItem,
                            'min_built_up_area',
                            listing.built_up_area ? this.addTSBV(listing.built_up_area) : ''
                        );
                        this.$set(
                            this.editedItem,
                            'max_built_up_area',
                            listing.built_up_area ? this.addTSBV(listing.built_up_area) : ''
                        );
                        this.$set(
                            this.editedItem,
                            'min_plot_area',
                            listing.plot_area ? this.addTSBV(listing.plot_area) : ''
                        );
                        this.$set(
                            this.editedItem,
                            'max_plot_area',
                            listing.plot_area ? this.addTSBV(listing.plot_area) : ''
                        );
                        this.builtUpAreaUnit = listing.built_up_area_unit || this.builtUpAreaUnit;
                        this.plotAreaUnit = listing.plot_area_unit || this.plotAreaUnit;
                        this.$set(this.editedItem, 'no_of_bedrooms', listing.no_of_bedrooms);
                        this.$set(this.editedItem, 'no_of_bathrooms', listing.no_of_bathrooms);
                        this.$set(
                            this.editedItem,
                            'min_price',
                            listing.min_sale_price ? this.addTSBV(listing.min_sale_price) : ''
                        );
                        this.$set(
                            this.editedItem,
                            'max_price',
                            listing.max_sale_price ? this.addTSBV(listing.max_sale_price) : ''
                        );
                        this.$set(this.editedItem, 'min_rent', '');
                        this.$set(this.editedItem, 'max_rent', '');
                    });
                });
        },
        getDevelopmentsByIds(ids) {
            this.$store.dispatch(DEVELOPMENTS_SIMPLE_BY_IDS_LIST, {'ids': ids})
                .then((data) => {
                    const list = (data.records.developmentsList || []).map((d) => this.mapLeadLocationItem({
                        id: d.id,
                        title: d.commercial_title,
                        commercial_title: d.commercial_title,
                        text: d.commercial_title,
                        type: d.type
                    }, 'development'));
                    this.locationsFilter = list;
                    this.developmentsFilter = data.records.developmentsList;
                }).then(() => {
                this.dialog = true
            }).then(() => {
                this.$set(this.editedItem, 'location_uids', this.locationsFilter.map((el) => el.uid));
                this.syncLeadLocationsToIds(this.editedItem);
            });
        },
        getProjectsByIds(ids) {
            this.$store.dispatch(PROJECTS_SIMPLE_BY_IDS_LIST, {'ids': ids})
                .then((data) => {
                    const list = (data.records.projectsList || []).map((p) => this.mapLeadLocationItem({
                        id: p.id,
                        title: p.title,
                        text: p.title
                    }, 'project'));
                    this.locationsFilter = list;
                    this.projectsFilter = data.records.projectsList;
                }).then(() => {
                this.dialog = true
            }).then(() => {
                this.$set(this.editedItem, 'location_uids', this.locationsFilter.map((el) => el.uid));
                this.syncLeadLocationsToIds(this.editedItem);
            });
        },
        updateSharedLeads(item) {
            this.showEditDialog(item)
        },
        showShareDialog() {
            this.shareDialog = true;
            this.leadSharingIds = this.$store.state.auth.user.lead_sharing_ids
        },
        shareLeads() {
            this.$store.dispatch(CLEAR_LEADS_ERRORS);
            this.$store.dispatch(SHARE_LEADS, {'user_ids': this.leadSharingIds}).then(() => {
                this.$store.dispatch(VERIFY_AUTH)
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.shareDialog = false
            })
        },
        showTree(id, type) {
            this.pagination.page = 1
            if (id !== 0) {
                const uid = type === 'project' ? ('project-' + id) : ('development-' + id);
                const current = Array.isArray(this.searchFormData.locationSearch)
                    ? [...this.searchFormData.locationSearch]
                    : [];
                if (!current.includes(uid)) {
                    current.push(uid);
                }
                this.$set(this.searchFormData, 'locationSearch', current);
                // Keep legacy keys in sync for older consumers / count APIs.
                if (type === 'project') {
                    this.$set(this.searchFormData, 'projectSearch', id);
                    this.$delete(this.searchFormData, 'developmentSearch');
                } else {
                    this.$set(this.searchFormData, 'developmentSearch', id);
                    this.$delete(this.searchFormData, 'projectSearch');
                }
                this.loadData().then(response => {
                    this.items = response.items;
                    this.totalRecords = response.total;
                    this.scrollToElement();
                });
            }
            if (type === 'development' || type === 'all') {
                let searchFormDataQuery = this.buildSearchFormQuery();
                this.$store.dispatch(DEVELOPMENTS_WITH_COUNT, {type: 'leads', 'id': id, 'get': type, query: searchFormDataQuery})
                    .then((data) => {
                        this.treeItems = data.records.developmentsList
                    })
            }
        },
        scrollToElement() {
            const el = this.$refs.scrollTo;
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
            }
        },
        verifyEmails() {
            this.$store.dispatch(VERIFY_EMAILS, {contactIds: this.mainDataTableSelection}).then((data) => {
                this.mainDataTableSelection = []
                this.emailDialog = true
                this.vEmails = data.records.emails
            })
        },
        saveLeadRR() {
            let that = this;
            this.$store.dispatch(CLEAR_LEADS_ERRORS);
            let data = {
                reason: this.leadRR,
                lead_id: this.leadRI.id,
                status: 0
            };
            this.$store.dispatch(UPDATE_LEADS_STATUS, {data: data})
                .then(() => {
                    that.leadRD = false
                    that.loadData().then(response => {
                        that.items = response.items;
                        that.totalRecords = response.total;
                    });
                });
        },
        leadStatusesChange(evt, item) {
            let that = this;
            if (evt === 1) {
                this.$store.dispatch(SET_CONFIRMATION, {
                    title: "Are you sure?",
                    msg: "You want to accept?",
                    clr: 'success',
                    callback: function () {
                        let id = item.id;
                        let sts = evt;
                        this.$store.dispatch(CLEAR_LEADS_ERRORS);
                        let data = {
                            lead_id: id,
                            status: sts
                        };
                        this.$store.dispatch(UPDATE_LEADS_STATUS, {data: data})
                            .then(() => {
                                that.loadData().then(response => {
                                    that.items = response.items;
                                    that.totalRecords = response.total;
                                });
                            });
                    }
                });
            } else {
                this.leadRD = true;
                this.leadRI = item
            }
        },
        showLeadCardToolbar(item) {
            if (this.showScope === 'assigned') {
                return true;
            }
            return Number(item.view_contact) === 1;
        },
        canEditLeadCard(item) {
            if (!this.hasPermission('leads.update')) {
                return false;
            }
            if (this.showScope !== 'assigned') {
                return true;
            }
            return Number(item.current_status) === 1;
        },
        leadCardToolbarHeight(item) {
            if (this.showScope === 'assigned' && Number(item.current_status) !== 1) {
                return '60';
            }
            return '40';
        }
    },
    computed: {
        isLeadsListBusy() {
            return !!this.loading;
        },
        leadsListTitle() {
            return this.showScope === 'assigned' ? 'Leads Assigned To Me' : 'All Leads';
        },
        hasLeadContacts() {
            return Array.isArray(this.editedItem.contact_ids) && this.editedItem.contact_ids.length > 0;
        },
        selectedLeadPropertyType() {
            const id = this.editedItem && this.editedItem.property_type_id;
            if (!id) return this.editedItem && this.editedItem.property_type ? this.editedItem.property_type : null;
            return (this.ptFilter || []).find((p) => Number(p.id) === Number(id))
                || (this.editedItem && this.editedItem.property_type)
                || null;
        },
        showLeadPlotAreas() {
            const type = this.selectedLeadPropertyType;
            if (!type) return false;
            const title = String(type.title || type.full_title || '').toLowerCase();
            return plotPropertyTypeKeywords.some((word) => title.includes(word));
        },
        isLeadCommercialPropertyType() {
            const type = this.selectedLeadPropertyType;
            if (!type) return false;
            const parentTitle = type.parent ? String(type.parent.title || '').toLowerCase() : '';
            const typeTitle = String(type.title || '').toLowerCase();
            const fullTitle = String(type.full_title || '').toLowerCase();
            return parentTitle.includes('commercial')
                || typeTitle.includes('commercial')
                || fullTitle.includes('commercial');
        },
        leadAreaUnitsFilter() {
            return (this.unitsFilter || []).filter((u) => u.value !== 'Dimensions');
        },
        params() {
            return {
                ...this.pagination,
                query: this.searchQuery
            };
        },
        ...mapState({
            errors: state => state.leads.errors
        }),
        pageCount() {
            // return this.totalRecords / this.pagination.rowsPerPage
            return this.params.itemsPerPage <= this.totalRecords ? Math.ceil(this.totalRecords / this.params.itemsPerPage) : 0
        },
        formattedViewsIds() {
            const formatted = [];
            this.viewsFilter.forEach((group, groupIndex) => {
                formatted.push({
                    header: group.title,
                    // header: group.title + ' (' + group.children.length + ')',
                    disabled: true
                });
                group.children.forEach((child, childIndex) => {
                    formatted.push({
                        id: child.id,
                        text: child.title,
                        value: `${groupIndex}_${childIndex}`,
                        originalTitle: child.title
                    });
                });
                if (groupIndex < this.viewsFilter.length - 1) {
                    formatted.push({
                        divider: true
                    });
                }
            });
            return formatted;
        }
    }
};
export default listingsScript